<template></template>
<script>
export default {
  name: "Logout",

  created() {
    sessionStorage.removeItem("session");
    window.location.href = "/login";
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue